<template>
  <div class="mt-1 w-full">
    <div class="flex">
      <!-- 左侧且或区域 -->
      <div
        v-if="(condition?.children?.length ?? 0) > 1"
        class="flex flex-col w-[20px]"
      >
        <div class="w-full flex-1 flex justify-center py-2 pt-3">
          <div class="border-l h-full opacity-30 border-[1px]" />
        </div>
        <div
          class="flex-shrink-0 cursor-pointer bg-[#0D84F2]/30 text-center hover:bg-[#0D84F2] text-sm"
          @click="toggleLogical"
        >
          {{ condition?.logicalOperator == 'and' ? '且' : '或' }}
        </div>
        <div class="w-full flex-1 flex justify-center py-2 pb-2">
          <div class="border-l h-full opacity-30 border-[1px]" />
        </div>
      </div>
      <!-- 右侧触发方式区域 -->
      <div class="flex-1">
        <div v-for="(t, index) in condition?.children" :key="t.id" :class="{}">
          <template v-if="t.flag == 'compare' && t.children?.length">
            <!-- 比较符类型 -->
            <div class="mt-2 ml-2">
              <CompareTypeSelect
                :compare="t"
                @change="(type:Compare['type']) => $emit('update', t.id, { compareType:type })"
              />
            </div>

            <ConditionWraper
              :addable="addable"
              :condition="t"
              :disabled="disabled"
              @delete=" (id:string)=> $emit('delete',id)"
              @add=" (id:string)=> $emit('add',id) "
              @update="(id:string, data:any) => $emit('update',id, data)"
            />
          </template>
          <CompareParam
            v-if="t.flag == 'compare-param'"
            :compare="condition"
            :compare-param="t"
            :compare-id="condition.id"
            :disabled="disabled"
            :label="'条件' + (index + 1)"
            :addable="addable && index == 0"
            class="mb-1"
            @delete=" (id:string)=> $emit('delete',id) "
            @add=" (compareId:string)=> $emit('add',compareId) "
            @update="(id:string, data:any) => $emit('update',id, data)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
const props = defineProps({
  condition: {
    type: Object as PropType<Condition | Compare>,
    required: true
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    required: true
  },
  addable: {
    type: Boolean as PropType<boolean>,
    required: true
  }
});

const toggleLogical = () => {
  if (props.disabled) return;
  emits('update', props.condition.id, {
    logicalOperator: props.condition?.logicalOperator == 'and' ? 'or' : 'and'
  });
};

const emits = defineEmits<{
  (event: 'update', id: string, data: Record<string, string | number>): void;
  (event: 'delete', id: string): void;
  (event: 'add', parentId: string): void;
}>();
</script>

<style scoped>
:deep(.trigger-input) * {
  text-align: center;
}

._grid {
  display: grid;
  grid-template-columns: 20px 1fr;
}
</style>
